import { sendEvent } from '~~/common/js/client/analytics';
import { getLabel, getTitle, URL_MAX_LENGTH, getTypeName } from './utils';

export const IMPRESSION = 'search_result_impression';
export const CLICK = 'search_result_click';
export const TYPE_AD = 'ad-text';
export const TYPE_DEEP_LINK = 'deep-link';
export const TYPE_PRODUCT_AD = 'product-ad';
export const TYPE_TOURS_ACTIVITIES_AD = 'tours-activities-ad';
export const TYPE_RELATED_SEARCH = 'related-search';
export const TYPE_WEB = 'organic';

const VERTICAL_IMAGES = 'images';
const VERTICAL_WEB = 'web';

// maps URL paths to verticals
const verticalsMap = {
  '/search': VERTICAL_WEB,
  '/images': VERTICAL_IMAGES,
};

const getVertical = () => verticalsMap[location?.pathname] ?? VERTICAL_WEB;

// It is slightly inefficient to do this every time trackImpression is called
// but to improve separation of concerns I decided not to force every caller
// to provide the query themselves and rather encapsulate the logic here.
const getQuery = () => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('q') ?? '';
};

const serialiseExtensions = (extensions = []) => extensions.map((extension) => extension.type).join(',');

const trackEvent = (eventName) => ({ type, url, title, position, rank, label = '', extensions }) => {
  sendEvent(
    eventName,
    {
      extensions: serialiseExtensions(extensions),
      label,
      position,
      query: getQuery(),
      rank,
      title,
      type,
      url,
      vertical: getVertical(),
    },
  );
};

//  tracking mainline & sidebar impression entries
// these are the types where we want to track impression events
export const trackedResultTypes = ['web', 'ad', 'newsSnippet', 'videosSnippet', 'imagesSnippet', 'productAds'];
export const getTrackingProperties = (result, props, trackingEntries) => {
  // only track some types. ignore entities for example
  if (trackedResultTypes.includes(result.type)) {
    // productAds need special treatment as they consist of multiple results
    if (result.type === 'productAds') {
      props.items.forEach((snippet) => {
        trackingEntries.push({
          url: snippet.url?.substring(0, URL_MAX_LENGTH).trim() || null,
          title: getTitle(snippet.title, result.type),
          rank: snippet.rank,
          result_type: getTypeName(result.type).trim(),
          result_label: null,
          list_ad_extensions: null,
        });
      });
    } else {
      trackingEntries.push({
        url: result.url?.substring(0, URL_MAX_LENGTH).trim() || null,
        title: getTitle(result.title, result.type),
        rank: props.rank,
        result_type: getTypeName(result.type).trim(),
        result_label: getLabel(result.domainLabel),
        list_ad_extensions: result.extensions?.length > 0 ?
          result.extensions.map((extension) => extension.type?.toLowerCase().trim()) :
          null,
      });
    }
  }
};

// used to track sidebar and mainline impressions
export const trackImpressions = (data) => ({
  tracker: 'trackSelfDescribingEvent',
  data: {
    schema: 'iglu:org.ecosia/result_impression_event/jsonschema/3-0-0',
    data: {
      query: data.query,
      vertical: 'web',
      impressions: data.impressions,
      page_position: data.page_position,
    },
  },
  context: ['mainCookie', 'abTests', 'requestID'],
});

export const trackImpression = trackEvent(IMPRESSION);
export const trackClick = trackEvent(CLICK);
